import React from 'react';
import PropTypes from 'prop-types';

const RadioButton = React.forwardRef((props, ref) => {
  const {
    className: classNameProp,
    defaultValue,
    label,
    id,
    name,
    onChange,
    type,
    ...rest
  } = props;
  return (
    <label className={`co-custom-radio ${classNameProp}`}>
      <input
        defaultValue={defaultValue}
        id={id}
        name={name}
        onChange={onChange}
        ref={ref}
        type='radio'
        {...rest}
      />
      <span className='checkmark'/>
      <span className='pl-1'>{label}</span>
    </label>
  )
});

export default RadioButton;
